// extracted by mini-css-extract-plugin
export default {"WordEmphasis":"WordEmphasis_WordEmphasis__uMwVn"};